import { mediaUp, styled } from "@veracity/vui"

export const LeftContainer = styled.divBox`

    margin-right: auto;

	${mediaUp("md")} {
		max-width: 720px;
	}

    width: 100%;

    > * {
		&:first-child {
			margin-top: 0;
		}
		&:last-child {
			margin-bottom: 0;
		}
	}
`;